import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'KDJ' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'KDJ', label: 'KDJ Stochastic', pane: 'sub', params: [9, 3, 3], outputs: ['k', 'd', 'j'], labels: ['K', 'D', 'J'] })
